AppBase.module(
  'Components.PhoneMulticomplete',
  function (Module, App, Backbone, Marionette, $, _) {
    'use strict'

    var Suggestions = App.Views.LayoutView.extend({
      template: 'phone_multicomplete/suggestions',

      behaviors: {
        SN_Theme: {},
      },

      regions: {
        suggestions: '.js-suggestionsChildWrapper',
      },

      initialize: function (options) {
        App.Views.LayoutView.prototype.initialize.call(this, options)

        _.bindAll(this, 'addSuggestion', 'emptyCollection')

        this.suggestions_collection = new App.Entities.PhoneNumbers()
        this.suggestions_view = null

        // @todo Using the `events` hash didn't work.
        this.listenTo(this, 'suggestions:hide', this.hideDropdown)
          .listenTo(this, 'suggestions:show', this.showDropdown)
          .listenTo(this, 'search:reset', this.emptyCollection)
          .listenTo(this, 'search:update', this.fetch)
      },

      onShow: function () {
        this.renderSuggestions()
      },

      /**
       * Inserts a dropdown to display suggestions.
       *
       * @private
       */
      renderSuggestions: function () {
        var view = new snui.Dropdown({
          data: this.suggestions_collection,
          data_type: 'options',
          theme: this.getOption('theme'),
        })
        this.suggestions_view = view

        // @todo If these are in `childEvents` the browser locks up when
        //   the events fire.
        this.listenTo(view, 'dropdown:options:selected', this.addSuggestion)
          .listenTo(view, 'childview:dom:refresh', this.injectFlags)
          .listenTo(view, 'childview:render', this.injectFlags)

        this.getRegion('suggestions').show(view)
      },

      /**
       * Add an item to the collection of selected numbers.
       *
       * @param {(model|model[])} models - Model(s) to add to collection.
       * @private
       */
      addSuggestion: function (models) {
        // Fixes an infinite loop: resetting `suggestions_collection`
        // makes the dropdown render, which always fires a
        // `dropdown:options:selected` event. In this case, it's a
        // notification that there are no selected options, so checking
        // for an empty collection prevents infinite collection resets.
        if (!models.length) return

        this.collection.add(models)

        this.emptyCollection()

        this.triggerMethod('suggestions:added')
      },

      /**
       * The search field has been cleared, so reset the suggestions
       * collection.
       *
       * @private
       */
      emptyCollection: function () {
        // Resets the suggestion view's collection of 'active' views to
        // prevent an infinite rendering loop. (Loop seems to be caused by
        // the view trying to re-add the selected item from its model in
        // `suggestions_collection`, but that model is invalid if the
        // collection has been reset.)
        this.suggestions_view.triggerMethod('dropdown:options:reset')

        this.suggestions_collection.reset()
      },

      /**
       * Fetch suggestions based on `value`.
       *
       * @param {string} value - The string to search for.
       *
       * @private
       */
      fetch: function (value) {
        this.suggestions_collection.fetch({
          data: {
            number: value,
          },
          success: this.reset,
          type: 'POST',
        })
      },

      /**
       * Hide the suggestions list.
       *
       * @private
       */
      hideDropdown: function () {
        this.suggestions_view.$el.fadeOut(Opal.Animations.fast)
      },

      /**
       * The `world-flags` CSS expects a structure of `.f16 .flag.us` (with
       * `.us` changing for each country code). The `PhoneNumbers` collection
       * automatically sets up the `.f16`, but Supernova's `Image` behavior
       * doesn't support child elements. This inserts the child element and
       * pulls the country code from a `flag-<country code>` class added to
       * the option.
       *
       * @param {Backbone.View} view - The view to use.
       *
       * @private
       */
      injectFlags: function (view) {
        var activeView = view || this.suggestions_view
        var $flags = activeView.$('.options-option .f16')

        $flags.each(function () {
          var $flag = $(this)
          var abbreviation

          if ($flag.children('.flag').length) return

          abbreviation = $flag.prop('class').split(/flag-(\w{2})/)[1]
          $flag.append('<div class="flag ' + abbreviation + '"></div>')
        })
      },

      /**
       * Show the suggestions view and make sure it's rendered correctly.
       *
       * @private
       */
      showDropdown: function () {
        // @todo There seems to be a timing issue that prevents
        //   `injectFlags` from working if the suggestions
        //   collection has few items.
        this.injectFlags()

        this.suggestions_view.$el.fadeIn(Opal.Animations.fast)

        this.suggestions_view.triggerMethod('view:scrollbar:refresh')
      },
    })
    Module.Suggestions = Suggestions
  }
)
